import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { getActiveCall } from '../../utils/callStatus';
import useTranslation from '../../hooks/useTranslation';

/**
 * Marker at the address of the visitor's own active call (a waving hand in a
 * red pin), so they see their request sitting on the map. Renders nothing
 * when there is no active call.
 */
const callIcon = L.divIcon({
    className: 'call-marker-icon',
    html:
        '<span class="call-marker">' +
        '<span class="call-marker-pin">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">' +
        '<path d="M7 11V6a2 2 0 0 1 4 0v4M11 7a2 2 0 0 1 4 0v3M15 8.5a2 2 0 0 1 4 0V14a6 6 0 0 1-6 6h-1.5a5 5 0 0 1-4-2l-3-4a1.6 1.6 0 0 1 2.5-2l1.5 1.6V7a2 2 0 0 1 4 0" fill="#FDFAF4"/>' +
        '</svg>' +
        '</span>' +
        '</span>',
    iconSize: [40, 52],
    iconAnchor: [20, 52],
    popupAnchor: [0, -46],
});

function CallMarker() {
    const { t } = useTranslation();
    const call = getActiveCall();
    if (!call || call.lat == null || call.lng == null) return null;

    const addressLine = [
        [call.straat, call.nr].filter(Boolean).join(' '),
        [call.postcode, call.gemeente].filter(Boolean).join(' '),
    ].filter(Boolean).join(', ');

    return (
        <Marker position={[call.lat, call.lng]} icon={callIcon} zIndexOffset={1500}>
            <Popup className="truck-popup">
                <div className="truck-popup-content">
                    <h6 className="truck-popup-title">{t('dialogs.callPlaced.mapTitle', 'Jouw oproep')}</h6>
                    {addressLine && <p className="truck-popup-subtitle">{addressLine}</p>}
                    <div className="truck-popup-status">
                        {call.aantal && <span className="status-text">{call.aantal} {t('dialogs.callPlaced.people', 'personen')}</span>}
                        {call.langskomenLabel && <span className="status-badge pill-green">{t('dialogs.callPlaced.until', 'tot')} {call.langskomenLabel}</span>}
                    </div>
                </div>
            </Popup>
        </Marker>
    );
}

export default CallMarker;
